export const FETCH_ALL_USERS_TIME_ENTRIES_BEGIN = 'FETCH_ALL_USERS_TIME_ENTRIES_BEGIN';
export const FETCH_ALL_USERS_TIME_ENTRIES_SUCCESS = 'FETCH_ALL_USERS_TIME_ENTRIES_SUCCESS';
export const FETCH_ALL_USERS_TIME_ENTRIES_ERROR = 'FETCH_ALL_USERS_TIME_ENTRIES_ERROR';
